<script setup>
import {computed, watch, getCurrentInstance} from 'vue'
import Listing from '../common/listing/Listing'

const {proxy} = getCurrentInstance()
const store = proxy.$store

// Accessing the route inside the computed ensures the dependency is tracked
const tableName = computed(() => {
    // Accessing proxy.$route.params here makes this computed reactive to URL changes
    const name = proxy.$route.params.component

    switch (name) {
        case 'orders':
            return 'm_basket_orders'
        case 'order_items':
            return 'm_basket_orderitems'
        default:
            return name
    }
})

// Watch remains the same
watch(tableName, (newName) => {
    if (newName) {
        store.commit('navigationComponent', newName)
    }
}, {immediate: true})
</script>

<template>
    <Listing :key="tableName" :table-name="tableName"/>
</template>